import { DEFAULT_DIGITS_AFTER_DECIMAL_POINT } from 'app-constants';

export const formatStringToNumber = (
  stringToFormat: string,
  digitsAfterDecimalPoint = DEFAULT_DIGITS_AFTER_DECIMAL_POINT,
  allowLeadingZero = false,
) => {
  const digitsAfterDecimalPointExist = Boolean(digitsAfterDecimalPoint);
  const regexIsFirstCharDot = /^[.,]/g;
  const regexIsFirstCharZeroOrDot = /^[0.]/g;
  const regexMultipleZeroAtBeginning = /^0+(?!$)/gi;
  const regexNumberPattern = new RegExp(
    `^[0-9]*${
      digitsAfterDecimalPointExist
        ? `(\\.[0-9]{0,${digitsAfterDecimalPoint}})?`
        : ''
    }`,
    'gi',
  );

  const dottedValue = stringToFormat.replace(',', '.');
  const valueWithoutZeroOrDot = dottedValue
    .replace(
      allowLeadingZero ? regexIsFirstCharDot : regexIsFirstCharZeroOrDot,
      '',
    )
    .replace(regexMultipleZeroAtBeginning, '');
  const finalValue = valueWithoutZeroOrDot.match(regexNumberPattern);

  return finalValue?.[0];
};

export const formatSystemToClientDate = (date: string): string =>
  date.split('-').reverse().join('.');

export const replacePathWithLogin = (url: string): string =>
  url.replace(/\/([^/]+)\/.*?(?=\?|$)/, '/$1/login');
